
import { Theme } from '@mui/material/styles';
import { withStyles } from 'tss-react/mui';
import classNames from 'classnames';
import ConditionValueEdit from '../ConditionValueEdit/ConditionValueEdit';
import {
  CondOperatorType,
  IClientAttributeModel,
} from '../../../../../../Types/ClientModelTypes';
import { IValue } from '../../../../../../Types/UrvalTypes';
import { conditionOperators } from '../ConditionOperator/Consts/ConditionOperatorConsts';

interface IProps {
  value: IValue;
  /** operatorn ska inte visas av den här komponenten, men kan påverka hur värdena visas */
  operator: CondOperatorType;
  setValue: (newValue: string | number | null) => void;
  setToValue: (newToValue: string | number | null) => void;
  attribute: IClientAttributeModel;
  disabled?: boolean;
  idx: number;
  classes?: any;
}

const styles = (theme: Theme) => ({
  inputContainer: {
    flex: 1,
    gap: theme.spacing(1),
    [theme.breakpoints.up('lg')]: {
      display: 'flex',
    },
  },
  valueEdit: {
    [theme.breakpoints.down('lg')]: {
      marginTop: theme.spacing(1),
      marginBottom: theme.spacing(1),
    },
  },
});

/**
Visar en rad med från och ev. till värde för en condition
*/
const ConditionValueViewUnstyled: React.FC<
  React.PropsWithChildren<IProps>
> = props => {
  const operator = conditionOperators[props.operator];
  const toValueLabel = operator.toValueLabel;
  const valueLabel = operator.valueLabel;

  const hasValue = valueLabel === 'har värde';
  const hasNoValue = valueLabel === 'saknar värde';

  return (
    <div className={props.classes.inputContainer}>
      {valueLabel !== '' && (
        <ConditionValueEdit
          id={`edtValue - ${props.attribute.AttributeName} - ${props.idx}`}
          label={valueLabel}
          value={props.value.value}
          onChange={props.setValue}
          attribute={props.attribute}
          disabled={hasValue || hasNoValue ? true : props.disabled}
          className={classNames({
            [props.classes.valueEdit]: toValueLabel !== '',
          })}
        />
      )}
      {toValueLabel !== '' && (
        <ConditionValueEdit
          id={`edtToValue - ${props.attribute.AttributeName} - ${props.idx}`}
          label={toValueLabel}
          value={props.value.toValue}
          onChange={props.setToValue}
          attribute={props.attribute}
          disabled={props.disabled}
        />
      )}
    </div>
  );
};

export const ConditionValueView = withStyles(
  ConditionValueViewUnstyled,
  styles
);
